<ng-container *ngIf="projetsList">
    <app-projets-list-dialog [projetDataType]="projetDataType" [proposedColumns]="columns" [projets]="projetsList"
        class="fullSpace">
    </app-projets-list-dialog>
</ng-container>
